import AuthLoader from "../components/Loader/AuthLoader";
import Loader from "../components/Loader/Loader";

/**
 * Get the appropriate suspense fallback based on current path
 * @returns {React.Element|null} The fallback component or null
 */
const SuspenseFallback = () => {
	const currentPath = window.location.pathname;

	const isNotCompleteProfilePath =
		currentPath === "/client/seller/complete-profile";
	const isDepotConnect = currentPath.includes("depot-connect");
	const isAuth = currentPath.includes("auth");

	if (isAuth) {
		return <AuthLoader />;
	}

	const shouldShowLoader = isNotCompleteProfilePath || isDepotConnect;

	return shouldShowLoader ? null : <Loader />;
};

export default SuspenseFallback;
